import { createI18n } from 'vue-i18n';

// i18n语种与elementPlus国际化对应map
export const LANG_ELEMENT_PLUS_MAP = {
  'zh-cn': 'zhCn' // 中文
};
// 后端语种与i18n的对应map
export const LANG_ELEMENT_MAP = {
  CN: 'zh-cn', // 中文
  EN: 'en', // 英语
  PH: 'ph', // 菲律宾用Tagalog
  TH: 'th', // 泰语
  KH: 'kh', // 柬埔寨
  MY: 'my', // 马来语
  ID: 'id', // 印尼语
  VN: 'vi', // 越南语
  AR: 'ar', // 阿拉伯语 -埃及、沙特、阿联酋
  ES: 'es', // 西班牙语-墨西哥
  PT: 'pt-br' // 葡萄牙语-巴西 目前只有巴西用葡萄牙语，如果以后有其他国家用葡萄牙，那这里不能用pt-br
};
const locale = LANG_ELEMENT_MAP[localStorage.getItem('lang') || 'CN'];
export default createI18n({
  legacy: false,
  locale: locale,
  fallbackLocale: locale,
  // 将其设为true,则所有前缀为$的属性和方法(只是vue-i18n所携带的)将被注入到所有vue组件中.
  // 即在所有组件中都可以使用 $i18n $t $rt $d $n $tm
  globalInjection: true, // 开启全局变量
  formatFallbackMessages: true, // 未配置翻译的使用原文
  missingWarn: false, // Whether suppress warnings outputted when localization fails.
  fallbackWarn: false // Whether suppress fall back warnings when localization fails.
});
